<h2 class="content-block">Home</h2>
<div class="content-block">
  <div class="dx-card responsive-paddings">
  </div>
</div>
